import {Component, Input} from '@angular/core';
import {
  Exemption_5_4_2
} from '@portbase/bezoekschip-service-typescriptmodels';
import {ExemptionBaseComponent} from "../../common/exemption_base/exemption_base.component";
import {PortvisitUtils} from "../../../../../refdata/portvisit-utils";

@Component({
    selector: 'app-visit-exemptions-exemption-5-4-2',
    templateUrl: './exemption_5_4_2.component.html',
    styleUrls: ['./exemption_5_4_2.component.css'],
    standalone: false
})
export class Exemption_5_4_2Component extends ExemptionBaseComponent {

  @Input() exemption: Exemption_5_4_2;

  portVisitUtils = PortvisitUtils;
  OTHER = 'Other';
  CONDITION_TYPE_01 = 'All cargo tanks (including slop tanks) are loaded or have been loaded with a flammable liquid with a flash point of ≥ 55°C, potassium hydroxide, sodium hydroxide, phosphoric acid and/or other substances that comply with Appendix 3 of the port regulations';
  CONDITION_TYPE_02 = 'All cargo tanks (including slop tanks) are completely empty and clean';
  CONDITION_TYPE_03 = 'Cargo tanks are loaded or empty but not gas-free';

  reasonTypes: string[] = [
    'Transshipment',
    'Repairs',
    'Cleaning',
    'Waiting',
    this.OTHER
  ];

  conditionTypes: string[] = [
    this.CONDITION_TYPE_01,
    this.CONDITION_TYPE_02,
    this.CONDITION_TYPE_03
  ];

  resetReason() {
    this.exemption.reason = '';
  }

  resetInertTanksDescription() {
    this.exemption.inertTanksDescription = '';
  }
}

